const _ = require('lodash'), templates = require('./detail-templates');

class RecipeService {
    constructor(restangular, $templateCache, _breakpointsService) {
        this.breakpointsService = _breakpointsService;

        this._api = restangular.one('recipes');
        _.forEach(templates, (template) => {
            $templateCache.put(template.id, template.content);
        });

        this.recipeDetailsCache = {};
    }

    getRecipes(recipeCategoryId, pageSize, pageNumber, sortType) {
        return this._api.get({
            recipeCategoryId,
            pageSize,
            pageNumber,
            sortType,
        }).then(response => ({
            items: response.Items,
            totalRecordCount: response.TotalRecordCount,
        }));
    }

    getRecipe(recipeId) {
        if (!(recipeId in this.recipeDetailsCache)) {
            this.recipeDetailsCache[recipeId] = this._api.one('', recipeId).get();
        }

        return this.recipeDetailsCache[recipeId];
    }

    emailRecipe(recipeUrl, recipientAddress, userEmail, message, sendCopy) {
        return this._api.post('email', {
            recipeUrl,
            toAddress: recipientAddress,
            from: userEmail,
            message,
            sendCopy,
        });
    }
}

module.exports = RecipeService;



// WEBPACK FOOTER //
// ./src/recipe/recipe.service.js